// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22H2V2H22V22ZM8 15V17H18V15H8ZM6 11V13H16V11H6ZM11 7V9H18V7H11Z"}}]};

const ViewGanttFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'view-gantt-filled',
    ref,
    icon: element,
  },
));

ViewGanttFilledIcon.displayName = 'ViewGanttFilledIcon';

export default ViewGanttFilledIcon;
